import { createTheme } from '@mui/material/styles';

const ACCENT = '#0D66D0'; // Adobe Blue

export const createAppTheme = ({ darkMode = true } = {}) => {
  const d = darkMode;
  return createTheme({
    palette: {
      mode: d ? 'dark' : 'light',
      primary: { main: ACCENT },
      secondary: { main: d ? '#ECECEC' : '#18181B' },
      background: {
        default: d ? '#09090B' : '#FAFAFA',
        paper: d ? '#111113' : '#FFFFFF',
      },
      text: {
        primary: d ? '#ECECEC' : '#18181B',
        secondary: d ? '#71717A' : '#52525B',
      },
      divider: d ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.08)',
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
      h1: { fontWeight: 650, fontSize: '1.75rem', letterSpacing: '-0.035em', lineHeight: 1.2 },
      h2: { fontWeight: 600, fontSize: '1.35rem', letterSpacing: '-0.025em', lineHeight: 1.3 },
      h3: { fontWeight: 600, fontSize: '1.05rem', letterSpacing: '-0.015em' },
      h4: { fontWeight: 600, fontSize: '1rem', letterSpacing: '-0.01em' },
      h5: { fontWeight: 600, fontSize: '0.95rem' },
      h6: { fontWeight: 600, fontSize: '0.9rem' },
      body1: { fontSize: '0.9rem', lineHeight: 1.65, fontWeight: 400 },
      body2: { fontSize: '0.84rem', lineHeight: 1.6, fontWeight: 400 },
      button: { textTransform: 'none', fontWeight: 550, letterSpacing: '-0.01em' },
      caption: { fontSize: '0.75rem', lineHeight: 1.4, letterSpacing: '0' },
    },
    shape: { borderRadius: 10 },
    transitions: { duration: { shorter: 150, short: 200, standard: 250 } },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: d ? '#09090B' : '#FAFAFA',
            transition: 'background-color 0.3s ease',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 8, padding: '7px 16px', fontWeight: 550, transition: 'all 0.15s ease' },
          contained: { boxShadow: 'none', '&:hover': { boxShadow: 'none' } },
        },
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: 'none' } },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            border: d ? '1px solid rgba(255,255,255,0.06)' : '1px solid rgba(0,0,0,0.06)',
            transition: 'border-color 0.15s, transform 0.15s',
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '0.72rem', fontWeight: 500,
            backgroundColor: d ? '#27272A' : '#18181B',
            color: '#FAFAFA', borderRadius: 6, padding: '4px 10px',
            border: d ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(255,255,255,0.12)',
          },
          arrow: { color: d ? '#27272A' : '#18181B' },
        },
      },
      MuiDialog: {
        styleOverrides: { paper: { backgroundImage: 'none' } },
      },
      MuiTextField: {
        defaultProps: { variant: 'outlined', size: 'small' },
      },
    },
  });
};

export const ACCENT_COLOR = ACCENT;
export default createAppTheme;
